export default __webpack_public_path__ + "static/media/D.f619e080.svg";